import PropTypes from 'prop-types';

export default {
  handleClose: PropTypes.func,
  termsOpened: PropTypes.bool,
  terms: PropTypes.object,
  classes: PropTypes.object,
};



// WEBPACK FOOTER //
// ./src/components/review/termsAndConditions/TermsDialogProps.js